<template>
  <QuestionBase
      :showQuestion="false"
      :question="question" :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
      :valid="!!data"
      :disabled-valid="true"
  >
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../../helpers/questionLoadHelpers";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";

import QuestionBase from "../../../../QuestionBase";

const numberWords = require('number-words');

export default {
  name: 'CashText',
  mixins: [questionLoadHelpers, saveHelpers],
  components: {
    QuestionBase
  },
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number,
      required: false
    },
    amount: {
      type: Number,
      required: false
    },
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
        if (this.noSave) return
        this.$nextTick(() => {
          this.save()
        })
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'Text?',
        subTitle: null,
        tip: null
      },
      db: {
        saveLocation: 'product_will_data',
        saveField: `${this.location}${this.index}CashText`,
        formPath: `data.${this.location}.details.gifts.${this.index}.text`,
        jsonSaveField: 'text'
      },
      args: {
        skippable: false,
        required: false,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  },
  methods: {
    setText() {
      this.$nextTick(() => {
        console.log('set text value')
        let words = numberWords.convert(this.amount)
        this.data = `${words} pounds`
      })

    }
  }
}
</script>
